import { dashedTitleRecipe } from '@/common/components/base/dashedTitle/dashedTitle.recipe';
import { DashedTitlePropsType } from '@/common/components/base/dashedTitle/DashedTitle.type';
import { FC } from 'react';
import { Box } from 'styled-system/jsx';

const DashedTitle: FC<DashedTitlePropsType> = ({
  title,
  className,
  ...rest
}) => {
  const classes = dashedTitleRecipe(rest);

  return (
    <Box display="flex" alignItems="center" gap="5px" className={className}>
      <p className={classes.title}>{title}</p>
      <Box borderBottom="1px solid {colors.gray-2}" width="100%" />
    </Box>
  );
};

export default DashedTitle;
